module.exports = __webpack_public_path__ + "media/images/icons/pencil-52c6d77eab0366378bff06c4cf128312.svg";